import React from 'react';

import {
  Box,
  styled
} from '@mui/material';
import {
  ApiRequestTable,
  LabelledText
} from 'modules/layer00';

import { BaseModal } from 'iron-forge-react-modules';
import * as dataService from './dataService';



const ContainerBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2)
}));

export interface IProps {
  refundId: string;
  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.refundId);

  const children = React.useCallback(
    () => (
      <ContainerBox>
        <LabelledText.FC
          title="Created at"
          text={queryTuple.data.refund?.createdAt.toFormat('yyyy-MM-dd') ?? ''} />

        <ApiRequestTable.FC
          apiRequests={queryTuple.data.refund?.apiRequests ?? []} />
      </ContainerBox>
    ),
    [queryTuple.data.refund]
  );



  return (
    <BaseModal.FC
      isOpen
      isDoubleWide
      onClose={props.onClose}>
      {children}
    </BaseModal.FC>
  );
};
